import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Coffee, Cookie, CupSoda, BookOpen } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    title: 'Recetario de mixología con café',
    desc: '50 recetas para preparar bebidas únicas.',
    value: 9.99,
    icon: CupSoda
  }, {
    title: 'Recetario de matcha',
    desc: '30 recetas modernas.',
    value: 7.99,
    icon: Coffee
  }, {
    title: 'Recetario de mixología con té',
    desc: '40 recetas.',
    value: 7.99,
    icon: CupSoda
  }, {
    title: 'Recetario de postres',
    desc: '50 postres ideales para acompañar tu café.',
    value: 9.99,
    icon: Cookie
  }, {
    title: 'Recetario de galletas',
    desc: '25 recetas.',
    value: 5.99,
    icon: Cookie
  }, {
    title: 'Recetario de barritas',
    desc: '25 recetas dulces.',
    value: 5.99,
    icon: Cookie
  }, {
    title: 'Recetario de batidos',
    desc: '30 bebidas refrescantes.',
    value: 7.99,
    icon: CupSoda
  }, {
    title: 'Recetario de jarabes',
    desc: '10 jarabes para preparar bebidas estilo cafetería.',
    value: 4.99,
    icon: Coffee
  }, {
    title: 'Mitos y verdades del café',
    desc: 'Descubre qué es mito y qué es realidad sobre tu bebida favorita.',
    value: 3.99,
    icon: BookOpen
  }, {
    title: 'Guía emprendedora: mi cafetería',
    desc: 'Convierte tu pasión por el café en un posible negocio.',
    value: 12.99,
    icon: BookOpen
  }];
  const totalValue = bonuses.reduce((acc, curr) => acc + curr.value, 0);
  return <section className="py-16 md:py-24 px-4 bg-espresso-900 text-cream-100" data-id="element-12">
      <div className="max-w-4xl mx-auto" data-id="element-13">
        <div className="text-center mb-16" data-id="element-14">
          <div className="inline-flex items-center justify-center p-4 bg-gold-500/20 rounded-full mb-6" data-id="element-15">
            <Gift className="w-10 h-10 text-gold-500" data-id="element-16" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gold-500 mb-4" data-id="element-17">
            ADEMÁS INCLUYE ESTOS BONOS DE REGALO
          </h2>
          <p className="text-xl text-cream-200" data-id="element-18">Exclusivos al comprar hoy</p>
        </div>

        <div className="space-y-6 mb-16" data-id="element-19">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} className="bg-espresso-800/50 border-l-4 border-gold-500 rounded-r-xl p-6 flex flex-col sm:flex-row items-start sm:items-center gap-6 hover:bg-espresso-800 transition-colors" data-id="element-20">
                <div className="bg-espresso-900 p-4 rounded-lg border border-espresso-700 flex-shrink-0" data-id="element-21">
                  <Icon className="w-8 h-8 text-gold-500" data-id="element-22" />
                </div>

                <div className="flex-1" data-id="element-23">
                  <div className="text-gold-500 text-sm font-bold tracking-wider mb-1" data-id="element-24">
                    BONUS {index + 1}
                  </div>
                  <h3 className="text-xl font-bold mb-2" data-id="element-25">{bonus.title}</h3>
                  <p className="text-cream-200/80" data-id="element-26">{bonus.desc}</p>
                </div>

                <div className="flex flex-col items-start sm:items-end mt-4 sm:mt-0 bg-espresso-900/50 px-4 py-2 rounded-lg" data-id="element-27">
                  <span className="text-sm text-cream-200/60" data-id="element-28">Valor:</span>
                  <span className="text-lg line-through text-cream-200/40" data-id="element-29">
                    ${bonus.value}
                  </span>
                  <span className="text-cta-600 font-bold text-xl" data-id="element-30">
                    ¡GRATIS!
                  </span>
                </div>
              </motion.div>;
        })}
        </div>

        {/* Total Value Summary */}
        <motion.div initial={{
        scale: 0.95,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-gold-600 to-gold-700 rounded-2xl p-8 md:p-12 text-center text-espresso-900 shadow-2xl relative overflow-hidden" data-id="element-31">
          <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" data-id="element-32"></div>
          <div className="relative z-10" data-id="element-33">
            <h3 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-34">
              Resumen de tu oferta hoy:
            </h3>
            <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-2xl md:text-4xl font-bold" data-id="element-35">
              <div className="flex flex-col items-center" data-id="element-36">
                <span className="text-sm uppercase tracking-widest opacity-80 mb-1" data-id="element-37">
                  Valor Total
                </span>
                <span className="line-through opacity-60" data-id="element-38">
                  ${totalValue.toFixed(2)}
                </span>
              </div>
              <span className="hidden md:inline" data-id="element-39">→</span>
              <div className="flex flex-col items-center" data-id="element-40">
                <span className="text-sm uppercase tracking-widest opacity-80 mb-1" data-id="element-41">
                  Hoy
                </span>
                <span className="text-white text-4xl md:text-5xl drop-shadow-md" data-id="element-42">
                  ¡GRATIS con tu compra!
                </span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}